import { type IconifyIcon } from '@iconify/react';
import { atom } from 'nanostores';

type ToolConfig = {
  id: string;
  label: string;
  icon?: string | IconifyIcon;
  canSelectObjects: boolean;
};

export const TOOLS = [
  {
    id: 'select',
    label: 'Select',
    icon: 'mdi:cursor-default',
    canSelectObjects: true,
  },
  {
    id: 'move',
    label: 'Move',
    icon: 'mdi:axis-arrow',
    canSelectObjects: true,
  },
  {
    id: 'resize',
    label: 'Resize',
    icon: 'mdi:resize',
    canSelectObjects: true,
  },
  {
    id: 'rotate',
    label: 'Rotate',
    icon: 'mdi:rotate-3d-variant',
    canSelectObjects: true,
  },
  {
    id: 'place',
    label: 'Place',
    canSelectObjects: false,
  },
] as const satisfies ToolConfig[];
export const TOOL_MAP = TOOLS.reduce(
  (map, tool) => {
    map[tool.id] = tool;
    return map;
  },
  {} as Record<ToolConfig['id'], ToolConfig>,
);
export type EditorTool = (typeof TOOLS)[number]['id'];

export const $activeTool = atom<EditorTool>(TOOLS[0].id);

export function setActiveTool(tool: EditorTool) {
  $activeTool.set(tool);
}

export function getActiveToolConfig() {
  return TOOL_MAP[$activeTool.get()]!;
}
